











































































































































































































































































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import deepmerge from 'deepmerge';
import {getValidationErrorText, EMOJI, TRAILING_AND_LEADING_SPACES} from '@/utils/validate';
import {dictionaryAddressTypes, mapDadataIntoSchema} from '@/utils/address';
import {getAddressStructure} from '@/api/address';
import EMOJI_REGEX from 'emojibase-regex';
import {requiredIf} from 'vuelidate/lib/validators';

export const addressValidate = () => ({
	regionName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	okato: {EMOJI, TRAILING_AND_LEADING_SPACES},
	oktmo: {EMOJI, TRAILING_AND_LEADING_SPACES},
	postalCode: {EMOJI, TRAILING_AND_LEADING_SPACES},
	areaName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	cityName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	cityDistrictName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	settlementName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	streetName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	houseName: {EMOJI, required: requiredIf((vm) => !vm?.buildingName), TRAILING_AND_LEADING_SPACES},
	buildingName: {EMOJI, required: requiredIf((vm) => !vm?.houseName), TRAILING_AND_LEADING_SPACES},
	block: {EMOJI, TRAILING_AND_LEADING_SPACES},
	flatName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	steadName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	roomName: {EMOJI, TRAILING_AND_LEADING_SPACES},
	militaryUnit: {EMOJI, TRAILING_AND_LEADING_SPACES},
	note: {EMOJI, TRAILING_AND_LEADING_SPACES},
});

const FiasLevel = {
	/** регион */
	REGION: '1',
	/** район */
	AREA: '3',
	/** город */
	CITY: '4',
	/** район города */
	CITY_DISTRICT: '5',
	/** населенный пункт */
	SETTLEMENT: '6',
	/** улица */
	STREET: '7',
	/** дом */
	HOUSE: '8',
	/** квартира или комната */
	FLAT: '9',
	/** планировочная структура */
	PLANNING_STRUCTURE: '65',
	/** земельный участок */
	STEAD: '75',
} as const;

const NOTE_FIAS_LEVELS_DEFAULT = [
	FiasLevel.PLANNING_STRUCTURE,
	FiasLevel.STEAD,
];
const NOTE_FIAS_LEVELS_NOTICE_RECOVERY = [FiasLevel.PLANNING_STRUCTURE];

const MODEL_MAP_DEFAULT: Record<string, string> = {
	fias_id: 'fiasCode',
	okato: 'okato',
	kladr_id: 'kladr',
	oktmo: 'oktmo',
	postal_code: 'postalCode',
	region: 'regionName',
	region_fias_id: 'regionFiasId',
	area: 'areaName',
	area_type: 'areaType',
	city: 'cityName',
	city_type: 'cityType',
	city_district: 'cityDistrictName',
	city_district_type: 'cityDistrictType',
	settlement: 'settlementName',
	settlement_type: 'settlementType',
	street: 'streetName',
	street_type: 'streetType',
	house: 'houseName',
	house_type: 'houseType',
	flat: 'flatName',
	flat_type: 'flatType',
	addressStr: 'addressStr',
	fias_level: 'fiasLevel',
	note: 'note',
};

const MODEL_MAP_NOTICE_RECOVERY: Record<string, string> = {
	...MODEL_MAP_DEFAULT,
	stead: 'steadName',
	stead_type: 'steadType',
	room: 'roomName',
	room_type: 'roomType',
	militaryUnit: 'militaryUnit',
};

@Component({
	data: () => ({getValidationErrorText}),
	inheritAttrs: false,
})
export default class AddressStructuredField extends Vue {
	@Prop() private value!: object;
	@Prop() private globalDisabled!: boolean;
	@Prop() private noticeRecovery!: boolean;
	@Prop() private v!: Function;
	@Prop({ type: String, default: 'common.addressComponent' }) private translationKey!: string;

	// ограничение поля 255 символов
	errorMaxLength = 255;
	errorMessageMaxLength = '';
	errorMessageEmoji = '';
	isShowFilds = false;
	isFocus = false;
	entries: any[] = [];
	isLoading = false;
	selectedAddress: null | any = null;
	areaOptions = dictionaryAddressTypes.district;
	cityOptions = dictionaryAddressTypes.city;
	settlementOptions = dictionaryAddressTypes.locality;

	modelDefault = {
		fiasCode: null,
		okato: null,
		kladr: null,
		oktmo: null,
		postalCode: null,
		regionName: null,
		regionFiasId: null,
		areaName: null,
		areaType: null,
		cityName: null,
		cityType: null,
		cityDistrictName: null,
		cityDistrictType: null,
		settlementName: null,
		settlementType: null,
		streetName: null,
		streetType: null,
		houseName: null,
		houseType: null,
		buildingName: null,
		buildingType: null,
		block: null,
		flatName: null,
		flatType: null,
		note: null,
		addressStr: null,
		fiasLevel: null,
		steadName: null,
		steadType: null,
		roomName: null,
		roomType: null,
		militaryUnit: null,
	};

	disabledDefault = {
		regionName: false,
		okato: false,
		oktmo: false,
		postalCode: false,
		areaName: false,
		areaType: false,
		cityName: false,
		cityType: false,
		cityDistrictName: false,
		cityDistrictType: false,
		settlementName: false,
		settlementType: false,
		streetName: false,
		streetType: false,
		houseName: false,
		houseType: false,
		buildingName: false,
		buildingType: false,
		block: false,
		flatName: false,
		flatType: false,
		note: false,
		steadName: false,
		roomName: false,
		militaryUnit: false,
	};

	model: any = {...this.modelDefault};
	disabled: any = {...this.disabledDefault};

	levels = [
		{level: FiasLevel.REGION, name: 'region'}, // регион
		{level: FiasLevel.AREA, name: 'area'}, // район
		{level: FiasLevel.CITY, name: 'city'}, // город
		{level: FiasLevel.CITY_DISTRICT, name: 'cityDistrict'}, // район города
		{level: FiasLevel.SETTLEMENT, name: 'settlement'}, // населенный пункт
		{level: FiasLevel.STREET, name: 'street'}, // улица
		{level: FiasLevel.HOUSE, name: 'stead'}, // для блокировки земельного участка при выборе уровня дома и ниже
		{level: FiasLevel.HOUSE, name: 'house'}, // дом
		{level: FiasLevel.FLAT, name: 'flat'}, // квартира
	];

	typesOptionsFias: any = {
		area_type: this.areaOptions, // предзаполнение Тип района в регионе
		city_type: this.cityOptions, // предзаполнение Мениципальное образование (город)
		settlement_type: this.settlementOptions, // предзаполнение Населенный пункт
		street_type: this.streetOptions, // предзаполнение Улица
		flat_type: this.apartmentOptions, // предзаполнение Квартира
	};

	typesOptionsModel: any = {
		areaType: this.areaOptions, // предзаполнение Тип района в регионе
		cityType: this.cityOptions, // предзаполнение Мениципальное образование (город)
		settlementType: this.settlementOptions, // предзаполнение Населенный пункт
		streetType: this.streetOptions, // предзаполнение Улица
		flatType: this.apartmentOptions, // предзаполнение Квартира
	};

	get errorMessageAutocomplete() {
		const errorArr = [];
		// ошибка максимальной длины
		if (this.errorMessageMaxLength) {
			errorArr.push(this.errorMessageMaxLength);
		}
		// ошибка emoji
		if (this.errorMessageEmoji) {
			errorArr.push(this.errorMessageEmoji);
		}
		return errorArr.length > 0 ? errorArr : getValidationErrorText(this.v);
	}

	get noteFiasLevels() {
		return this.noticeRecovery
			? NOTE_FIAS_LEVELS_NOTICE_RECOVERY
			: NOTE_FIAS_LEVELS_DEFAULT;
	}

	get modelMap() {
		return this.noticeRecovery ? MODEL_MAP_NOTICE_RECOVERY : MODEL_MAP_DEFAULT;
	}

	get streetOptions() {
		return this.noticeRecovery
			? dictionaryAddressTypes.street
			: dictionaryAddressTypes.streetWithSteed;
	}

	get apartmentOptions() {
		return this.noticeRecovery
			? dictionaryAddressTypes.apartment
			: dictionaryAddressTypes.apartmentWithRoom;
	}

	@Watch('model', {deep: true})
	onChangedModel() {
		this.$emit('change', this.mappingTypes(this.model, this.modelMap));
	}

	@Watch('value', {deep: true})
	onChangedValue() {
		// @ts-ignore
		if (this.value && this.value.isEsia) {
			this.prefillEsia();
		}
	}

	updateInput(word: any) {
		// Когда очищаем поле поиска вручную, обновляем родительскую модель
		if (!word && this.isFocus) {
			this.isShowFilds = false;
			this.selectedAddress = null;
			this.$emit('change', {});
		}

		this.errorMessageMaxLength = '';
		if (word && word.length >= this.errorMaxLength) {
			this.errorMessageMaxLength = `Максимальная длина поля ${this.errorMaxLength} символов`;
		}

		this.errorMessageEmoji = '';
		if (word && word.match(EMOJI_REGEX)) {
			this.errorMessageEmoji = `Некорректный формат`;
		}
	}

	created() {
		if (this.value && Object.keys(this.value).length !== 0) {
			this.model = this.mappingValueModel(this.value);
			this.isShowFilds = true;
		}
		// @ts-ignore
		if (this.value && this.value.isEsia) {
			this.prefillEsia();
		}
	}

	prefillEsia() {
		this.selectedAddress = this.value;
		this.onSelectedAddress();
		this.prefillInput(this.value);
	}

	onFocus() {
		this.isFocus = true;
	}

	/*
	 *  Получаем список адресов из дадаты
	 */
	loadEntries(value: any) {
		if (value && value.length >= this.errorMaxLength) {
			return;
		}

		this.isLoading = true;
		getAddressStructure(value)
			.then((res: any) => {
				const {suggestions} = res;
				this.entries = suggestions.map((item: any) => ({
					...item,
					data: {...item.data, addressStr: item.value},
				}));
			})
			// .catch(err => {
			//   console.log(err);
			// })
			.finally(() => (this.isLoading = false));
	}

	/*
	 *  Получаем из дадаты адрес и предзаполняем форму (модель)
	 */
	onSelectedAddress() {
		// Когда очичаем поле поиска, обновляем родительскую модель
		if (!this.selectedAddress) {
			this.isShowFilds = false;
			this.$emit('change', {});
			return;
		}

		this.isShowFilds = true;
		const selectedAddress: any = {...this.selectedAddress};

		// обнуляем модель и задизейбливание
		this.model = {...this.modelDefault};
		this.disabled = {...this.disabledDefault};

		// Предзапоолняем модель данными из фиас и запрещаем к ним доступ
		for (const key in selectedAddress) {
			if (Boolean(this.modelMap[key]) && Boolean(selectedAddress[key])) {
				this.model[this.modelMap[key]] = selectedAddress[key];
				this.disabled[this.modelMap[key]] = true;

				// предзаполняем типы в селекте
				if (key.includes('_type') && this.typesOptionsFias[key]) {
					this.typesOptionsFias[key].forEach((element: any) => {
						if (element.type.includes(selectedAddress[key])) {
							this.model[this.modelMap[key]] = element.type;
						}
					});
				}
				// если уровень фиас, который мы не учитываем
				if (
					key === 'fias_level' &&
					this.noteFiasLevels.includes(selectedAddress[key])
				) {
					this.model.note = selectedAddress.addressStr;
				}
			}

			// мапинг корпуса и строения
			if (key === 'block') {
				const blockOrBuilding = mapDadataIntoSchema(selectedAddress);
				this.model = deepmerge(this.model, blockOrBuilding);
				this.disabled.block = !!blockOrBuilding.block;
				this.disabled.buildingName = !!blockOrBuilding.buildingName;
			}
		}

		// Запрещаем доступ ко всем полям, выше найденного уровня fias_level (задизейбливаем)
		this.disabledFildsPrefill(selectedAddress.fias_level);
	}

	/*
	 *  Избавляемся от массива в типах.
	 *  Массив нужен для корректной работы выбора типов, т.к. имеются множественные сокращения у каждого типа
	 */
	mappingTypes(model: any, modelMap: any) {
		const newModel: any = {};
		const modelMapRevert = Object.fromEntries(
			Object.entries(modelMap).map(([key, value]) => [value, key])
		);
		for (const key in model) {
			if (Array.isArray(model[key])) {
				if (this.selectedAddress[modelMapRevert[key]]) {
					// предзаполняем родной из дадаты
					newModel[key] = this.selectedAddress[modelMapRevert[key]];
				} else {
					// считаем что заполнили с формы, и выбираем первый из массива
					newModel[key] = model[key][0];
				}
			} else {
				newModel[key] = model[key];

				// предзаполняем тип дома, при ручном вводе
				if (key === 'houseType' && Boolean(model['houseName'])) {
					newModel[key] = 'д';
				}
				// предзаполняем тип строения
				if (key === 'buildingType' && Boolean(model['buildingName'])) {
					newModel[key] = 'стр';
				}
				if (key === 'roomType' && Boolean(model['roomName'])) {
					newModel[key] = 'ком';
				}
				if (key === 'steadType' && Boolean(model['steadName'])) {
					newModel[key] = 'уч';
				}
			}
		}
		return newModel;
	}

	/*
	 *  Проставляем массивы в типы.
	 *  Массив нужен для корректной работы выбора типов, т.к. имеются множественные сокращения у каждого типа
	 */
	mappingValueModel(valueProp: any) {
		const newModel = {...this.model, ...valueProp};

		for (const key in valueProp) {
			if (key.includes('Type') && this.typesOptionsModel[key]) {
				this.typesOptionsModel[key].forEach((element: any) => {
					if (element.type.includes(valueProp[key])) {
						newModel[key] = element.type;
					}
				});
			}
		}

		// предзаполняем autocomplete
		this.prefillInput(newModel);
		// Запрещаем доступ ко всем полям выше найденного уровня fias_level (задизейбливаем)
		this.disabledFildsPrefill(valueProp.fiasLevel, true);
		return newModel;
	}

	prefillInput(newModel: any) {
		// предзаполняем autocomplete
		this.selectedAddress = newModel.addressStr;
		this.entries = [{value: newModel.addressStr}];
	}

	disabledFildsPrefill(fiasLevel: any, isCreated?: boolean) {
		let innerFiasLevel = fiasLevel;

		if (fiasLevel === FiasLevel.STEAD) {
			innerFiasLevel = FiasLevel.STREET; // для блокировки полей уровня улица и выше

			if (isCreated) {
				this.disabled.steadName = true;
			}
		}

		// Запрещаем доступ ко всем полям выше найденного уровня fias_level (задизейбливаем)
		for (const levelEl of this.levels) {
			if (innerFiasLevel >= levelEl.level) {
				this.disabled[levelEl.name + 'Name'] = true;
				this.disabled[levelEl.name + 'Type'] = true;
			}
		}

		// запрещаем ОКАТО, ОКТМО, почтовый индекс
		this.disabled['okato'] = !!fiasLevel;
		this.disabled['oktmo'] = !!fiasLevel;
		this.disabled['postalCode'] = !!fiasLevel;
	}
}
